/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CandidateOffersIdApplyQuestions model module.
 * @module model/CandidateOffersIdApplyQuestions
 * @version v1
 */
class CandidateOffersIdApplyQuestions {
    /**
     * Constructs a new <code>CandidateOffersIdApplyQuestions</code>.
     * @alias module:model/CandidateOffersIdApplyQuestions
     */
    constructor() { 
        
        CandidateOffersIdApplyQuestions.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CandidateOffersIdApplyQuestions</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CandidateOffersIdApplyQuestions} obj Optional instance to populate.
     * @return {module:model/CandidateOffersIdApplyQuestions} The populated <code>CandidateOffersIdApplyQuestions</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CandidateOffersIdApplyQuestions();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('answer_id')) {
                obj['answer_id'] = ApiClient.convertToType(data['answer_id'], 'Number');
            }
            if (data.hasOwnProperty('answer_text')) {
                obj['answer_text'] = ApiClient.convertToType(data['answer_text'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
CandidateOffersIdApplyQuestions.prototype['id'] = undefined;

/**
 * Para las respuestas closed
 * @member {Number} answer_id
 */
CandidateOffersIdApplyQuestions.prototype['answer_id'] = undefined;

/**
 * Para las respuestas open
 * @member {String} answer_text
 */
CandidateOffersIdApplyQuestions.prototype['answer_text'] = undefined;






export default CandidateOffersIdApplyQuestions;

